import ExpandMore from '@mui/icons-material/ExpandMore';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary, {
	AccordionSummaryProps,
} from '@mui/material/AccordionSummary';
import { styled } from '@mui/material/styles';

export const Accordion = styled((props: AccordionProps) => (
	<MuiAccordion disableGutters elevation={0} square {...props} />
))(
	({
		theme: {
			spacing,
			palette: {
				gray: { main },
			},
		},
	}) => ({
		border: 0,
		paddingTop: spacing(2),
		borderBottom: `1px solid black`,
		'&.Mui-expanded': {
			background: main,
		},
		'&:before': {
			display: 'none',
		},
	})
);

export const AccordionSummary = styled((props: AccordionSummaryProps) => (
	<MuiAccordionSummary expandIcon={<ExpandMore />} {...props} />
))(() => ({
	'& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
		transform: 'rotate(180deg)',
		backgroundColor: 'transparent',
	},
}));

export const AccordionDetails = styled(MuiAccordionDetails)(
	({
		theme: {
			spacing,
			palette: {
				gray: { main },
			},
		},
	}) => ({
		padding: spacing(2),
		background: main,
	})
);
